const now = new Date()

export default [
  /* {
    id: 0,
    title: 'All Day Event very long title',
    allDay: true,
    start: new Date(2015, 3, 0),
    end: new Date(2015, 3, 1),
  }, */
  {
    id: 1,
    title: 'SFL Audit Training',
    start: new Date(now.getFullYear(), now.getMonth(), 15, 10, 0, 0), // January 15th, 2025, 10:00 AM
    end: new Date(now.getFullYear(), now.getMonth(), 16, 12, 0, 0),   // January 15th, 2025, 12:00 PM
  },
  {
    id: 9,
    title: 'jan training',
    start: new Date(now.getFullYear(), now.getMonth(), 15, 10, 0, 0), // January 15th, 2025, 10:00 AM
    end: new Date(now.getFullYear(), now.getMonth(), 16, 12, 0, 0),   // January 15th, 2025, 12:00 PM
  },
  {
    id: 2,
    title: 'SFL Field training',
    start: new Date(now.getFullYear(), now.getMonth(), 19, 10, 0, 0), // January 15th, 2025, 10:00 AM
    end: new Date(now.getFullYear(), now.getMonth(), 19, 12, 0, 0),   // January 15th, 2025, 12:00 PM
  },
  {
    id: 3,
    title: 'Demo Training ',
    agenda:"training example",
    start: new Date(now.getFullYear(), now.getMonth(), 21, 10, 0, 0), // January 15th, 2025, 10:00 AM
    end: new Date(now.getFullYear(), now.getMonth(), 28, 12, 0, 0),   // January 15th, 2025, 12:00 PM
  }
]